import { ConfigReportComboApi } from "go-report-combo/User/services/types";

export const REPORT_sales_source = {
	id: "REPORT_sales_source",
	name: "Sales location source",
	data: [
		{
			id: "TRANSACTION_PAID",
			resource: "TRANSACTION",
			filter: "partner_type|e=SALEçtransaction_type_quantity|e=NEWçorganization_partner|ne=571",
			groups: ["NONE", "COMPANY_SOURCE"],
			columns: [
				{
					id: "summary",
					filter: "paid_at|bt={date_range__QUARTER}",
				},
			],
		},
		{
			id: "TRANSACTION_PAYMENT_DUE",
			resource: "TRANSACTION",
			filter: "partner_type|e=SALEçtransaction_type_quantity|e=NEWçstatus|e=PAYMENT_DUEçorganization_partner|ne=571",
			groups: ["NONE", "COMPANY_SOURCE"],
			columns: [
				{
					id: "summary",
					filter: "transaction_at|bt={date_range__QUARTER}",
				},
			],
		},
	],
	rows: [
		{
			id: "SUMMARY",
			name: "Wszystkie",
			type: "CALCULATE",
			group: "COMPANY_SOURCE",
			aggregate: "TRANSACTION_PAYMENT_DUE.new_quantity_customer + TRANSACTION_PAID.new_quantity_customer",
		},
		{
			id: "TRANSACTION_PAID",
			name: "TRANSACTION_PAID",
			data_id: "TRANSACTION_PAID",
			group: "COMPANY_SOURCE",
			aggregate: "new_quantity_customer",
		},
		{
			id: "TRANSACTION_PAYMENT_DUE",
			name: "TRANSACTION_PAYMENT_DUE",
			data_id: "TRANSACTION_PAYMENT_DUE",
			group: "COMPANY_SOURCE",
			aggregate: "new_quantity_customer",
		},
	],
	columns: [
		{
			id: "new_locations",
			data_column_id: "summary",
			name: "Lokalizacje",
		},
	],
} as ConfigReportComboApi;
